<template>
  <!-- 下拉框组件 -->
  <div class="selectComponent" @click.stop>
    <p @click="needShow=!needShow">
        {{selectList[needindex].title}}
        <img src="@/assets/jianTou.png" :style="{transform: needShow?'rotate(180deg)':'rotate(90deg)'}"/>
    </p>
    <transition name="el-zoom-in-top">
        <ul v-show="needShow">
            <li v-for="(item,index) in selectList" :key="index" @click="selectClickLi(item,index)">{{item.title}}</li>
        </ul>
    </transition>
  </div>
</template>

<script>
    export default {
        name: 'selectComponent',
        props:{
            selectList:{
                default:[]
            },
            defaultData:{ //默认选择哪个 传下标
                default:0
            }
        },
        data () {
            return {
                needShow:false,
                needindex:0
            }
        },
        methods:{
            selectClickLi(item,index){
                this.needindex=index;
                this.needShow=!this.needShow;
                this.$emit("no-selectBottom",item)
            }
        },
        mounted(){
            this.needindex=Number(this.defaultData);
            document.body.addEventListener('click',  () => {
                this.needShow = false
            })
        }
    }
</script>

<style scoped lang="less">
    .selectComponent{
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        p{
            height: 100%;
            display: flex;
            align-items: center;
            cursor: pointer;
            img{
                height: 12px;
                transform: rotate(90deg);
                transition: 0.3s;
            }
        }
        ul{
            position: absolute;
            top:180%;
            left:-1px;
            width: 100%;
            // height: 150px;
            background: #ffffff;
            // overflow: auto;
            border-radius: 4px;
            padding: 10px 0;
            border: 1px solid #EBEEF5;
            box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
            z-index: 5;
            // border:1px solid #152f6a;
            li{
                height: 36px;
                text-align: center;
                line-height: 36px;
                color: #606266;
                cursor: pointer;
            }
            li:hover{
                background-color: #ecf5ff;
                color: #66b1ff;
            }
        }
        ul:after{
            content: "";
            position:absolute;
            top:-6px;
            left: 44%;
            width:0;
            height:0;
            border-left:6px solid transparent;
            border-right:6px solid transparent;
            border-bottom:7px solid #ffffff;
        }
    }

    ul li:hover {
        background-color: #ecf5ff !important;
        color: #1966FF !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/common/select/index.vue